module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Lloyd’s Wharf, Sittingbourne",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--lloyds-wharf.netlify.app/' : 'https://www.lloydswharf.info',

    holding: {
        "brand": "https://via.placeholder.com/300x200?text=Brand+image",
        "message": "Website coming soon"
    },

    base: {
        "contact_address": "",
        "contact_number": "0800 246 5890",
        "contact_email": "consultation@lloydswharf.info"
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "",
        "description": "",
        "gtag": "G-V5MNCQB0CJ",
        "gtm": "GTM-PQXVTNH"
    },

    form: {
        "contact": {
            "catcher_id": "",
            "recaptcha": "",
            "honeypot": ""
        },
        "feedback": {
            "catcher_id": "",
            "recaptcha": "6LcCRSAdAAAAAGFSZod4wC3u6sTXl08mqlF43EfU",
            "honeypot": ""
        }
    },

    consultation: {   
        "feedback_active": false, 
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "This consultation is closed and is no longer accepting feedback.",
        
        // Consultation close countdown. If set to true, show countdown in site header
        "has_countdown": false,
        "countdown_end": "03/31/2022 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

        "themes": [
            {
                "name": "First theme",
                "url": "section-1",
                "feedback_url": '',
                "icon": "drainage_strategy",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "01-section"
            },
            {
                "name": "Second theme",
                "url": "section-2",
                "feedback_url": 'page-2/',
                "icon": "heritage",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "02-section"
            },
            {
                "name": "Third theme",
                "url": "section-3",
                "feedback_url": 'page-3/',
                "icon": "environment",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "03-section"
            },
            {
                "name": "Fourth theme",
                "url": "section-4",
                "feedback_url": 'page-4/',
                "icon": "leisure_and_recreation",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "04-section"
            },
            {
                "name": "Fifth theme",
                "url": "section-5",
                "feedback_url": 'page-5/',
                "icon": "highways_and_transport",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "05-section"
            },
            {
                "name": "Sixth theme",
                "url": "section-6",
                "feedback_url": 'page-6/',
                "icon": "uncategorised",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "06-section"
            }
        ]
    },

    downloads: [
        {
            "title": "Architects’ presentation",
            "url": "/assets/images/pdf/LloydsWharf-ArchitectPresentation.pdf"
        }
    ],
    
    faqs: [
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
    ],

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    // Bugsnag API Key
    bugsnagApiKey: '8cb9cd1215bf16d2e0015fa69a74b89a',

    // Marker.io Key - replace this default key
    marker_io: '618d2de7be76ee21e8452764'
};